import {customAxiosBE} from "../config";

export async function getCityZonesAPI(onlyActive) {
    const params = onlyActive === undefined ? "" : `?onlyActive=${onlyActive}`;
    return customAxiosBE.get(`/city/zone${params}`);
}

export async function insertCityZoneAPI(payload) {
    return customAxiosBE.post(`/city/zone`, payload);
}

export async function updateCityZoneAPI(id, payload) {
    return customAxiosBE.put(`/city/zone/${id}`, payload);
}

export async function deleteCityZoneAPI(id) {
    return customAxiosBE.delete(`/city/zone/${id}`);
}

export async function getCityLinesAPI() {
    return customAxiosBE.get(`/city/line`);
}

export async function getCityLineByIdAPI(id) {
    return customAxiosBE.get(`/city/line/${id}`);
}

export async function insertCityLineAPI(payload) {
    return customAxiosBE.post(`/city/line`, payload);
}

export async function updateCityLineAPI(id, payload) {
    return customAxiosBE.put(`/city/line/${id}`, payload);
}

export async function deactivateCityLineAPI(id) {
    return customAxiosBE.delete(`/city/line/${id}`);
}

export async function getCityLineNoteAPI(id) {
    return customAxiosBE.get(`/city/line/${id}/note`);
}

export async function saveCityLineNoteAPI(id, payload) {
    return customAxiosBE.put(`/city/line/${id}/note`, payload);
}

export async function getCityRouteExceptionsAPI(memberLineId) {
    return customAxiosBE.get(`/city/route-exception?memberLineId=${memberLineId}`);
}

export async function insertCityRouteExceptionAPI(payload) {
    return customAxiosBE.post(`/city/route-exception`, payload);
}

export async function updateCityRouteExceptionAPI(id, payload) {
    return customAxiosBE.put(`/city/route-exception/${id}`, payload);
}

export async function deleteCityRouteExceptionAPI(id) {
    return customAxiosBE.delete(`/city/route-exception/${id}`);
}

export async function getCityTimetableAPI(cityLineId, stationId) {
    const query = stationId ? `?stationId=${stationId}` : "";
    return customAxiosBE.get(`/city/line/${cityLineId}/timetable${query}`);
}

export async function getCityDeparturesAPI(memberLineId) {
    return customAxiosBE.get(`/city/departure?memberLineId=${memberLineId}`);
}

export async function saveCityOffsetsAPI(memberLineId, payload) {
    return customAxiosBE.put(`/city/departure/offsets/${memberLineId}`, payload);
}

export async function addCityDepartureAPI(payload) {
    return customAxiosBE.post(`/city/departure`, payload);
}

export async function recalculateCityOffsetsAPI(payload) {
    return customAxiosBE.put(`/city/departure/recalculate`, payload);
}

export async function generateCityDeparturesAPI(payload) {
    return customAxiosBE.post(`/city/departure/generate`, payload);
}

export async function copyCityDeparturesAPI(payload) {
    return customAxiosBE.post(`/city/departure/copy`, payload);
}

export async function deleteCityDepartureAPI(tripId) {
    return customAxiosBE.delete(`/city/departure/${tripId}`);
}

export async function setCityDepartureVehicleAPI(tripId, vehicleId) {
    const query = vehicleId ? `?vehicleId=${vehicleId}` : "";
    return customAxiosBE.put(`/city/departure/${tripId}/vehicle${query}`);
}

export async function getCityVehiclePlanAPI(cityLineId, payload) {
    return customAxiosBE.post(`/city/departure/${cityLineId}/vehicle-plan`, payload);
}

export async function applyCityVehiclePlanAPI(cityLineId, payload) {
    return customAxiosBE.post(`/city/departure/${cityLineId}/vehicle-plan/apply`, payload);
}

export async function assignCityVehiclesAPI(cityLineId, payload) {
    return customAxiosBE.post(`/city/departure/vehicles/${cityLineId}`, payload);
}

export async function getCityTripOffsetsAPI(tripId) {
    return customAxiosBE.get(`/city/departure/${tripId}/offsets`);
}

export async function saveCityTripOffsetsAPI(payload) {
    return customAxiosBE.put(`/city/departure/trip-offsets`, payload);
}

export async function getCityExceptionAPI(periodId) {
    return customAxiosBE.get(`/city/exception/${periodId}`);
}

export async function saveCityExceptionAPI(periodId, tripIds) {
    return customAxiosBE.put(`/city/exception/${periodId}`, {tripIds});
}

export async function getCitySettingsAPI() {
    return customAxiosBE.get(`/city/fare/settings`);
}

export async function saveCitySettingsAPI(payload) {
    return customAxiosBE.put(`/city/fare/settings`, payload);
}

export async function saveCitySurchargeAPI(payload) {
    return customAxiosBE.put(`/city/fare/surcharge`, payload);
}

export async function getCityZoneRatesAPI(ticketKind, ticketTypeId) {
    const parts = [];
    if (ticketKind) {
        parts.push(`ticketKind=${ticketKind}`);
    }
    if (ticketTypeId) {
        parts.push(`ticketTypeId=${ticketTypeId}`);
    }
    return customAxiosBE.get(`/city/fare/zone-rate${parts.length ? `?${parts.join("&")}` : ""}`);
}

export async function getCityTicketTypesAPI({onlyCity} = {}) {
    return customAxiosBE.get(`/city/fare/ticket-type${onlyCity ? "?onlyCity=true" : ""}`);
}

export async function saveCityZoneRatesAPI(payload) {
    return customAxiosBE.put(`/city/fare/zone-rate`, payload);
}

export async function getCitySaleOptionsAPI() {
    return customAxiosBE.get(`/city/fare/sale-options`);
}

export async function getCityPassProductsAPI() {
    return customAxiosBE.get(`/city/fare/product`);
}

export async function saveCityPassProductAPI(id, payload) {
    return id
        ? customAxiosBE.put(`/city/fare/product/${id}`, payload)
        : customAxiosBE.post(`/city/fare/product`, payload);
}

export async function deleteCityPassProductAPI(id) {
    return customAxiosBE.delete(`/city/fare/product/${id}`);
}

export async function findCityCardAPI(cardNumber) {
    return customAxiosBE.get(`/city/card?cardNumber=${encodeURIComponent(cardNumber)}`);
}

export async function searchCityCardsAPI(term) {
    return customAxiosBE.get(`/city/card/search?term=${encodeURIComponent(term)}`);
}

export async function getCityCardAPI(cardId) {
    return customAxiosBE.get(`/city/card/${cardId}`);
}

export async function issueCityCardAPI(payload) {
    return customAxiosBE.post(`/city/card`, payload);
}

export async function updateCityCardAPI(cardId, payload) {
    return customAxiosBE.put(`/city/card/${cardId}`, payload);
}

export async function topUpCityCardAPI(payload) {
    return customAxiosBE.post(`/city/card/top-up`, payload);
}

export async function settleCityCardFeeAPI(payload) {
    return customAxiosBE.post(`/city/card/fee`, payload);
}

export async function blacklistCityCardAPI(cardId, payload) {
    return customAxiosBE.post(`/city/card/${cardId}/blacklist`, payload);
}

export async function payCitySurchargeMonthlyAPI(payload) {
    return customAxiosBE.post(`/city/card/surcharge-monthly`, payload);
}

export async function replaceCityCardAPI(cardId, payload) {
    return customAxiosBE.post(`/city/card/${cardId}/replace`, payload);
}

export async function correctCityWalletAPI(payload) {
    return customAxiosBE.post(`/city/card/correction`, payload);
}

export async function sellCityPassAPI(payload) {
    return customAxiosBE.post(`/city/card/pass`, payload);
}

export async function uploadCityCardPhotoAPI(cardId, image) {
    return customAxiosBE.post(`/city/card/${cardId}/photo`, {image});
}

export async function deleteCityCardPhotoAPI(cardId) {
    return customAxiosBE.delete(`/city/card/${cardId}/photo`);
}

export async function getCityAccountPassesAPI({from, to, tin, term}) {
    const parts = [`from=${from}`, `to=${to}`];
    if (tin) {
        parts.push(`tin=${encodeURIComponent(tin)}`);
    }
    if (term) {
        parts.push(`term=${encodeURIComponent(term)}`);
    }
    return customAxiosBE.get(`/city/card/account-passes?${parts.join("&")}`);
}

export async function getCityAccountBuyersAPI() {
    return customAxiosBE.get(`/city/card/account-buyers`);
}

export async function cancelCityPassAPI(passId) {
    return customAxiosBE.delete(`/city/card/pass/${passId}`);
}

export async function getCityTrafficReportAPI({from, to, cityLineId, lineId, regime, zoneId}) {
    const parts = [`from=${from}`, `to=${to}`];
    if (cityLineId) {
        parts.push(`cityLineId=${cityLineId}`);
    }
    if (lineId) {
        parts.push(`lineId=${lineId}`);
    }
    if (regime) {
        parts.push(`regime=${regime}`);
    }
    if (zoneId) {
        parts.push(`zoneId=${zoneId}`);
    }
    return customAxiosBE.get(`/city/report/traffic?${parts.join("&")}`);
}

export async function getCityKmReportAPI({from, to, cityLineId, lineId, regime, status}) {
    const parts = [`from=${from}`, `to=${to}`];
    if (cityLineId) {
        parts.push(`cityLineId=${cityLineId}`);
    }
    if (lineId) {
        parts.push(`lineId=${lineId}`);
    }
    if (regime) {
        parts.push(`regime=${regime}`);
    }
    if (status) {
        parts.push(`status=${status}`);
    }
    return customAxiosBE.get(`/city/report/km?${parts.join("&")}`);
}

export async function getCityVehicleReportAPI({from, to, cityLineId, vehicleId}) {
    const parts = [`from=${from}`, `to=${to}`];
    if (cityLineId) {
        parts.push(`cityLineId=${cityLineId}`);
    }
    if (vehicleId) {
        parts.push(`vehicleId=${vehicleId}`);
    }
    return customAxiosBE.get(`/city/report/vehicle?${parts.join("&")}`);
}

export async function getCityDeviceReportAPI({from, to, kind}) {
    return customAxiosBE.get(`/city/report/device?from=${from}&to=${to}${kind ? `&kind=${kind}` : ""}`);
}

export async function getCityFinanceReportAPI({from, to, channels, payments, fiscal, cashier}) {
    const params = new URLSearchParams({from, to});
    if (channels?.length) {
        params.append("channels", channels.join(","));
    }
    if (payments?.length) {
        params.append("payments", payments.join(","));
    }
    if (fiscal) {
        params.append("fiscal", fiscal);
    }
    if (cashier) {
        params.append("cashier", cashier);
    }
    return customAxiosBE.get(`/city/report/finance?${params.toString()}`);
}

export async function getCityInspectionSummaryAPI({from, to}) {
    return customAxiosBE.get(`/city/report/inspection?from=${from}&to=${to}`);
}

export async function getCityInspectionDetailAPI({inspector, from, to}) {
    return customAxiosBE.get(`/city/report/inspection/detail?inspector=${encodeURIComponent(inspector)}`
        + `&from=${from}&to=${to}`);
}

export async function getCityValidationReportAPI({from, to, cardId, onlyRejected, cardNumber, clientName,
                                                     clientSurname}) {
    const parts = [`from=${from}`, `to=${to}`];
    if (cardId) {
        parts.push(`cardId=${cardId}`);
    }
    if (onlyRejected) {
        parts.push("onlyRejected=true");
    }
    if (cardNumber) {
        parts.push(`cardNumber=${encodeURIComponent(cardNumber)}`);
    }
    if (clientName) {
        parts.push(`clientName=${encodeURIComponent(clientName)}`);
    }
    if (clientSurname) {
        parts.push(`clientSurname=${encodeURIComponent(clientSurname)}`);
    }
    return customAxiosBE.get(`/city/report/validation?${parts.join("&")}`);
}

export async function getCityCardListAPI({term, onlyActive, status, onlyDebt, ticketTypeIds}) {
    const parts = [];
    if (term) {
        parts.push(`term=${encodeURIComponent(term)}`);
    }
    if (onlyActive) {
        parts.push("onlyActive=true");
    }
    if (status) {
        parts.push(`status=${status}`);
    }
    if (onlyDebt) {
        parts.push("onlyDebt=true");
    }
    (ticketTypeIds || []).forEach((id) => parts.push(`ticketTypeIds=${id}`));
    return customAxiosBE.get(`/city/card/list${parts.length ? `?${parts.join("&")}` : ""}`);
}

export async function renewCityPassesAPI(data) {
    return customAxiosBE.post(`/city/card/pass/bulk`, data);
}

export async function getCityTicketsAPI({from, to, kind, onlyCanceled, onlyFiscal, term, cityLineId, lineId,
                                            tripId, seller}) {
    const parts = [`from=${from}`, `to=${to}`];
    if (cityLineId) {
        parts.push(`cityLineId=${cityLineId}`);
    }
    if (lineId) {
        parts.push(`lineId=${lineId}`);
    }
    if (tripId) {
        parts.push(`tripId=${tripId}`);
    }
    if (seller) {
        parts.push(`seller=${encodeURIComponent(seller)}`);
    }
    if (kind) {
        parts.push(`kind=${kind}`);
    }
    if (onlyCanceled) {
        parts.push("onlyCanceled=true");
    }
    if (onlyFiscal) {
        parts.push("onlyFiscal=true");
    }
    if (term) {
        parts.push(`term=${encodeURIComponent(term)}`);
    }
    return customAxiosBE.get(`/city/card/tickets?${parts.join("&")}`);
}

export async function refundCityInvoiceAPI(payload) {
    return customAxiosBE.post(`/city/card/invoice-refund`, payload);
}

export async function getCityInvoicesAPI({from, to, cardNumber, tin, cashier, jid}) {
    const parts = [`from=${from}`, `to=${to}`];
    if (jid) {
        parts.push(`jid=${encodeURIComponent(jid)}`);
    }
    if (cardNumber) {
        parts.push(`cardNumber=${encodeURIComponent(cardNumber.trim())}`);
    }
    if (tin) {
        parts.push(`tin=${encodeURIComponent(tin.trim())}`);
    }
    if (cashier) {
        parts.push(`cashier=${encodeURIComponent(cashier)}`);
    }
    return customAxiosBE.get(`/city/card/invoices?${parts.join("&")}`);
}

export async function getCityTransactionsAPI({from, to, cardId, term, tin}) {
    const parts = [`from=${from}`, `to=${to}`];
    if (cardId) {
        parts.push(`cardId=${cardId}`);
    }
    if (term) {
        parts.push(`term=${encodeURIComponent(term)}`);
    }
    if (tin) {
        parts.push(`tin=${encodeURIComponent(tin)}`);
    }
    return customAxiosBE.get(`/city/card/transactions?${parts.join("&")}`);
}

export async function getLineRoutesAPI({cityLineId, lineId} = {}) {
    const parts = [];
    if (cityLineId) {
        parts.push(`cityLineId=${cityLineId}`);
    }
    if (lineId) {
        parts.push(`lineId=${lineId}`);
    }
    return customAxiosBE.get(`/line-route${parts.length ? `?${parts.join("&")}` : ""}`);
}

export async function getLineRouteAPI(id) {
    return customAxiosBE.get(`/line-route/${id}`);
}

export async function getLineRouteEditorAPI(lineId) {
    return customAxiosBE.get(`/line-route/line/${lineId}/editor`);
}

export async function getLineRouteVersionsAPI(lineId) {
    return customAxiosBE.get(`/line-route/line/${lineId}/versions`);
}

export async function insertLineRouteAPI(payload) {
    return customAxiosBE.post(`/line-route`, payload);
}

export async function updateLineRouteAPI(id, payload) {
    return customAxiosBE.put(`/line-route/${id}`, payload);
}

export async function activateLineRouteAPI(id, validFrom) {
    return customAxiosBE.post(`/line-route/${id}/activate`, {validFrom});
}

export async function copyLineRouteAPI(id, toLineId) {
    return customAxiosBE.post(`/line-route/${id}/copy?toLineId=${toLineId}`);
}

export async function deleteLineRouteDraftAPI(id) {
    return customAxiosBE.delete(`/line-route/${id}`);
}

export async function getCityEmployeeSettlementAPI(from, to, dayBasis) {
    return customAxiosBE.get(`/city/employee-settlement?from=${from}&to=${to}${dayBasis ? `&dayBasis=${dayBasis}` : ""}`);
}

export async function getCityEmployeeSettlementSalesAPI({from, to, kind, employee}) {
    return customAxiosBE.get(`/city/employee-settlement/sales?from=${from}&to=${to}&kind=${kind}`
        + `&employee=${encodeURIComponent(employee || "")}`);
}

export async function settleCityEmployeeAPI(data) {
    return customAxiosBE.post(`/city/employee-settlement`, data);
}

export async function getCityCashJournalAPI({from, to, kind, cashier, employee}) {
    const params = new URLSearchParams({from, to});
    if (kind) {
        params.append("kind", kind);
    }
    if (cashier) {
        params.append("cashier", cashier);
    }
    if (employee) {
        params.append("employee", employee);
    }
    return customAxiosBE.get(`/city/employee-settlement/journal?${params.toString()}`);
}

export async function getCityEmployeeDepositsAPI({year, kind}) {
    return customAxiosBE.get(`/city/employee-deposit?year=${year}${kind ? `&kind=${kind}` : ""}`);
}

export async function insertCityEmployeeDepositAPI(data) {
    return customAxiosBE.post(`/city/employee-deposit`, data);
}

export async function insertCityEmployeeDepositsBulkAPI(data) {
    return customAxiosBE.post(`/city/employee-deposit/bulk`, data);
}

export async function updateCityEmployeeDepositAPI(id, data) {
    return customAxiosBE.put(`/city/employee-deposit/${id}`, data);
}

export async function cancelCityEmployeeDepositAPI(id) {
    return customAxiosBE.delete(`/city/employee-deposit/${id}`);
}
